<template lang="pug">
  v-card.text-center.mt-3.py-2.px-1(flat)
    h4(v-if="title") {{ title }}
    v-row(no-gutters)
      v-col.column-five.mt-2(
        v-for='(item,i) in range'
        :key='i'
      )
        v-btn-toggle(
          v-model='items'
          multiple
          color='#ff8283'
          borderless
          tile
        )
          v-btn(
            :value='i'
            @click='$emit("click",i)'
          ) {{ i }}

</template>
<script>
export default {
  props:{
    title: {
      type: String,
      default:null
    },
    value:{
      type:Array,
      default:() => []
    },
    range: {
      type:Number,
      default:10
    }
  },
  data: () => ({
    items:[]
  }),
  watch: {
    value (val) {
      this.items = val
    },
    items (val) {
      this.$emit('input',val)
    }
  }
}
</script>